import { Inject, Injectable } from '@angular/core';
import { APP_CONFIG, EnvironmentModel } from '@fh-client-interaction-frontends/fh-app-config';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { AdhesionPaymentModel } from '../../../helpers/objects/dto/sales-portal/adhesion-payment/adhesion-payment-model';
import { map } from 'rxjs';
import { AdhesionPaymentResponseModel } from '../../../helpers/objects/response/sales-portal/adhesion-payment/adhesion-payment-response-model';
import { AdhesionMbPaymentResponseModel } from '../../../helpers/objects/response/sales-portal/adhesion-mb-payment/adhesion-mb-payment-response-model';
import { AdhesionMbPaymentStatusResponseModel } from '../../../helpers/objects/response/sales-portal/adhesion-mb-payment/adhesion-mb-payment-status-response-model';

@Injectable({
  providedIn: 'root'
})
export class PaymentDataAdhesionService {
  appConfig: EnvironmentModel = new EnvironmentModel();
  private readonly selectedApi : string = '';

  constructor(
    private http: HttpClient,
    @Inject(APP_CONFIG) protected appConfigTemp: EnvironmentModel
  ) {
    this.appConfig = appConfigTemp;

    if(this.appConfig.platform === 'fhps'){
      this.selectedApi = this.appConfig.api + 'external/'
    } else {
      this.selectedApi = this.appConfig.api
    }
  }

  setPayment(id: number, body: AdhesionPaymentModel) {
    let url: string =
      this.selectedApi + 'subscription/' + this.appConfig.apiPartnershipId + '/proposals/' + id + '/payment';

    return this.http.post<any>(url, body).pipe(map((response) => response.body as AdhesionPaymentResponseModel));
  }
  setFirstPayment(id: number, body: AdhesionPaymentModel) {
    let url: string =
      this.selectedApi+
      'subscription/' +
      this.appConfig.apiPartnershipId +
      '/proposals/' +
      id +
      '/first-payment';

    return this.http.post<any>(url, body);
  }

  getMbwayPayment(id: number) {
    let url: string =
      this.selectedApi+
      'subscription/' +
      this.appConfig.apiPartnershipId +
      '/proposals/' +
      id +
      '/payment/mpayment';

    return this.http.get<any>(url).pipe(map((result) => result.body as AdhesionMbPaymentResponseModel));
  }
  getMbwayPaymentStatus(id: number, transactionId: any) {
    const headers = new HttpHeaders({ 'X-TransactionId': transactionId });
    let url: string =
      this.selectedApi+
      'subscription/' +
      this.appConfig.apiPartnershipId +
      '/proposals/' +
      id +
      '/payment/mpaymentstatus';

    return this.http.get<any>(url, { headers }).pipe(map((result) => result.body as AdhesionMbPaymentStatusResponseModel));
  }
}
